// extracted by mini-css-extract-plugin
export var airline = "AirlineCard-module--airline--fa76d";
export var contentContainer = "AirlineCard-module--contentContainer--e1588";
export var heading = "AirlineCard-module--heading--378c1";